// // import React, { useState, useEffect, useRef } from 'react';
// // import { Link, useNavigate } from 'react-router-dom';

// // const BusinessHeader = () => {
// //     const navigate = useNavigate();
// //     const [showDropdown, setShowDropdown] = useState(false);
// //     const dropdownRef = useRef(null);

// //     const handleLogout = () => {
// //         console.log('Logging out...');
// //         navigate('/');
// //     };

// //     const toggleDropdown = () => {
// //         setShowDropdown(!showDropdown);
// //     };

// //     // Close dropdown when clicking outside
// //     useEffect(() => {
// //         const handleClickOutside = (event) => {
// //             if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
// //                 setShowDropdown(false);
// //             }
// //         };

// //         document.addEventListener('mousedown', handleClickOutside);
// //         return () => {
// //             document.removeEventListener('mousedown', handleClickOutside);
// //         };
// //     }, []);

// //     return (
// //         <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm fixed-top py-3">
// //             <div className="container">
// //                 {/* Brand Logo */}
// //                 <Link className="navbar-brand d-flex align-items-center" to="/business/dashboard">
                                       
// //                                        {/* MF MONOGRAM */}
// //                                        <svg
// //                                            width="52"
// //                                            height="52"
// //                                            viewBox="0 0 180 120"
// //                                            xmlns="http://www.w3.org/2000/svg"
// //                                            style={{ marginRight: '5px' }}
// //                                        >
// //                                            <text
// //                                                x="0"
// //                                                y="90"
// //                                                fontFamily="Playfair Display, Didot, serif"
// //                                                fontSize="96"
// //                                                fontWeight="700"
// //                                                letterSpacing="-10"
// //                                                fill="#111"
// //                                            >
// //                                                MF
// //                                            </text>
// //                                        </svg>
               
// //                                        {/* WORDMARK */}
// //                                        <div className="d-flex flex-column">
// //                                            <span
// //                                                style={{
// //                                                    fontSize: '1.05rem',
// //                                                    fontWeight: '500',
// //                                                    letterSpacing: '0.35rem',
// //                                                    color: '#111',
// //                                                    lineHeight: '1.1'
// //                                                }}
// //                                            >
// //                                                MUNNY FINDS
// //                                            </span>
               
// //                                            {/* <span
// //                                                style={{
// //                                                    fontSize: '0.55rem',
// //                                                    letterSpacing: '0.25rem',
// //                                                    fontWeight: '600',
// //                                                    color: '#6b7280',
// //                                                    marginTop: '2px'
// //                                                }}
// //                                            >
// //                                                BEAUTY & CARE
// //                                            </span> */}
// //                                             <span className="text-uppercase fw-bold text-muted" style={{ fontSize: '0.6rem', letterSpacing: '0.1rem' }}>Business Control</span>
// //                                        </div>
               
// //                                    </Link>
               

// //                 <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#adminNavbar">
// //                     <span className="navbar-toggler-icon"></span>
// //                 </button>

// //                 <div className="collapse navbar-collapse" id="adminNavbar">
// //                     <ul className="navbar-nav mx-auto mb-2 mb-lg-0 gap-lg-3">
// //                         <li className="nav-item">
// //                             <Link className="nav-link fw-semibold text-dark" to="/business/dashboard">
// //                                 <i className="ri-dashboard-line me-1"></i> Dashboard
// //                             </Link>
// //                         </li>
// //                         <li className="nav-item">
// //                             <Link className="nav-link fw-semibold text-dark" to="/business/appointmentslist">
// //                                 <i className="ri-group-line me-1"></i> Appointments
// //                             </Link>
// //                         </li>
// //                         <li className="nav-item">
// //                             <Link className="nav-link fw-semibold text-dark" to="/business/staffs">
// //                                 <i className="ri-user-line me-1"></i> Staffs
// //                             </Link>
// //                         </li>
// //                         <li className="nav-item">
// //                             <Link className="nav-link fw-semibold text-dark" to="/business/services">
// //                                 <i className="ri-list-check me-1"></i> Services
// //                             </Link>
// //                         </li>
// //                     </ul>
                    
// //                     <div className="d-flex align-items-center gap-3" ref={dropdownRef}>
// //                         {/* User Profile Dropdown */}
// //                         <div className="dropdown" style={{ position: 'relative' }}>
// //                             <button 
// //                                 className="btn btn-transparent d-flex align-items-center justify-content-center p-0" 
// //                                 type="button" 
// //                                 onClick={toggleDropdown}
// //                                 style={{ 
// //                                     backgroundColor: 'transparent', 
// //                                     border: 'none',
// //                                     width: '42px',
// //                                     height: '42px'
// //                                 }}
// //                             >
// //                                 <div className="rounded-circle d-flex align-items-center justify-content-center"
// //                                      style={{ 
// //                                          backgroundColor: '#065f46', 
// //                                          width: '36px', 
// //                                          height: '36px', 
// //                                          color: '#fff',
// //                                          cursor: 'pointer'
// //                                      }}>
// //                                     <i className="ri-user-fill"></i>
// //                                 </div>
// //                             </button>
                            
// //                             {/* Dropdown Menu */}
// //                             {showDropdown && (
// //                                 <div 
// //                                     className="dropdown-menu show shadow border-0"
// //                                     style={{
// //                                         position: 'absolute',
// //                                         right: 0,
// //                                         top: '100%',
// //                                         marginTop: '0.5rem',
// //                                         minWidth: '200px',
// //                                         backgroundColor: 'white',
// //                                         borderRadius: '0.375rem',
// //                                         zIndex: 1050,
// //                                         display: 'block',
// //                                         border: '1px solid rgba(0,0,0,.15)'
// //                                     }}
// //                                 >
// //                                     <Link 
// //                                         className="dropdown-item d-flex align-items-center py-2 px-3" 
// //                                         to="/business/profile"
// //                                         onClick={() => setShowDropdown(false)}
// //                                         style={{ textDecoration: 'none', color: '#212529' }}
// //                                     >
// //                                         <i className="ri-user-line me-2"></i>
// //                                         <span>Profile</span>
// //                                     </Link>
                                    
// //                                     <Link 
// //                                         className="dropdown-item d-flex align-items-center py-2 px-3" 
// //                                         to="/changepassword"
// //                                         onClick={() => setShowDropdown(false)}
// //                                         style={{ textDecoration: 'none', color: '#212529' }}
// //                                     >
// //                                         <i className="ri-lock-line me-2"></i>
// //                                         <span>Change Password</span>
// //                                     </Link>
                                    
// //                                     <hr className="dropdown-divider my-1 mx-3" />
                                    
// //                                     <button 
// //                                         className="dropdown-item d-flex align-items-center py-2 px-3 text-danger" 
// //                                         onClick={() => {
// //                                             setShowDropdown(false);
// //                                             handleLogout();
// //                                         }}
// //                                         style={{ 
// //                                             cursor: 'pointer',
// //                                             border: 'none',
// //                                             backgroundColor: 'transparent',
// //                                             width: '100%',
// //                                             textAlign: 'left'
// //                                         }}
// //                                     >
// //                                         <i className="ri-logout-box-r-line me-2"></i>
// //                                         <span>Logout</span>
// //                                     </button>
// //                                 </div>
// //                             )}
// //                         </div>
// //                     </div>
// //                 </div>
// //             </div>
// //         </nav>
// //     );
// // };

// // export default BusinessHeader;

// // web view 


// import React, { useState, useEffect, useRef } from 'react';
// import { Link, useNavigate } from 'react-router-dom';

// const BusinessHeader = () => {
//     const navigate = useNavigate();
//     const [showDropdown, setShowDropdown] = useState(false);
//     const [isMenuOpen, setIsMenuOpen] = useState(false);
//     const dropdownRef = useRef(null);

//     // If you have the salon name in localStorage, you can get it here:
//     // const salonName = localStorage.getItem('salonName') || 'My Salon';
//     const salonName = "My Salon"; // Placeholder - Replace with your actual data variable

//     const handleLogout = () => {
//         setIsMenuOpen(false);
//         console.log('Logging out...');
//         navigate('/');
//     };

//     const toggleDropdown = () => {
//         setShowDropdown(!showDropdown);
//     };

//     useEffect(() => {
//         const handleClickOutside = (event) => {
//             if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//                 setShowDropdown(false);
//             }
//         };
//         document.addEventListener('mousedown', handleClickOutside);
//         return () => document.removeEventListener('mousedown', handleClickOutside);
//     }, []);

//     return (
//         <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm fixed-top py-2">
//             <div className="container">
//                 {/* BRAND LOGO - ORIGINAL STYLES PRESERVED */}
//                 <Link className="navbar-brand d-flex align-items-center" to="/business/dashboard" onClick={() => setIsMenuOpen(false)}>
//                     <svg
//                         width="52"
//                         height="52"
//                         viewBox="0 0 180 120"
//                         xmlns="http://www.w3.org/2000/svg"
//                         style={{ marginRight: '5px' }}
//                     >
//                         <text
//                             x="0"
//                             y="90"
//                             fontFamily="Playfair Display, Didot, serif"
//                             fontSize="96"
//                             fontWeight="700"
//                             letterSpacing="-10"
//                             fill="#111"
//                         >
//                             MF
//                         </text>
//                     </svg>

//                     <div className="d-flex flex-column">
//                         <span
//                             style={{
//                                 fontSize: '1.05rem',
//                                 fontWeight: '500',
//                                 letterSpacing: '0.35rem',
//                                 color: '#111',
//                                 lineHeight: '1.1'
//                             }}
//                         >
//                             MUNNY FINDS
//                         </span>
//                         <span className="text-uppercase fw-bold text-muted" style={{ fontSize: '0.6rem', letterSpacing: '0.1rem' }}>
//                             Business Control
//                         </span>
//                     </div>
//                 </Link>

//                 <button 
//                     className="navbar-toggler shadow-none border-0" 
//                     type="button" 
//                     onClick={() => setIsMenuOpen(!isMenuOpen)}
//                 >
//                     <span className="navbar-toggler-icon"></span>
//                 </button>

//                 <div className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`} id="businessNavbar">
//                     <ul className="navbar-nav mx-auto mb-2 mb-lg-0 gap-lg-3 text-start ps-lg-0 ps-2">
//                         <li className="nav-item">
//                             <Link className="nav-link fw-semibold text-dark py-2" to="/business/dashboard" onClick={() => setIsMenuOpen(false)}>
//                                 <i className="ri-dashboard-line me-1"></i> Dashboard
//                             </Link>
//                         </li>
//                         <li className="nav-item">
//                             <Link className="nav-link fw-semibold text-dark py-2" to="/business/appointmentslist" onClick={() => setIsMenuOpen(false)}>
//                                 <i className="ri-calendar-check-line me-1"></i> Appointments
//                             </Link>
//                         </li>
//                         <li className="nav-item">
//                             <Link className="nav-link fw-semibold text-dark py-2" to="/business/staffs" onClick={() => setIsMenuOpen(false)}>
//                                 <i className="ri-user-line me-1"></i> Staffs
//                             </Link>
//                         </li>
//                         <li className="nav-item">
//                             <Link className="nav-link fw-semibold text-dark py-2" to="/business/services" onClick={() => setIsMenuOpen(false)}>
//                                 <i className="ri-list-check me-1"></i> Services
//                             </Link>
//                         </li>
//                     </ul>
                    
//                     {/* PROFILE DROPDOWN WITH SALON NAME (Matching Admin Style) */}
//                     <div className="d-flex align-items-center gap-3 ps-2 ps-lg-0 mt-2 mt-lg-0" ref={dropdownRef}>
//                         <div className="dropdown position-relative w-100">
//                             <button 
//                                 className="btn d-flex align-items-center gap-2 border-0 bg-transparent p-1 shadow-none" 
//                                 type="button" 
//                                 onClick={toggleDropdown}
//                             >
//                                 <div className="rounded-circle d-flex align-items-center justify-content-center"
//                                      style={{ 
//                                          backgroundColor: '#065f46', 
//                                          width: '35px', 
//                                          height: '35px', 
//                                          color: '#fff' 
//                                      }}>
//                                     <i className="ri-user-line fs-6"></i>
//                                 </div>
                                
//                                 {/* SALON NAME - Hidden on mobile, visible on desktop */}
//                                 <span className="fw-semibold text-dark d-none d-md-inline" style={{ fontSize: '0.9rem' }}>
//                                     {salonName}
//                                 </span>
//                                 {/* Mobile-only label */}
//                                 <span className="fw-semibold text-dark d-md-none">My Salon</span>
                                
//                                 <i className={`ri-arrow-down-s-line ${showDropdown ? 'rotate-180' : ''}`}></i>
//                             </button>
                            
//                             {showDropdown && (
//                                 <>
//                                     <div className="d-none d-lg-block position-fixed top-0 start-0 w-100 h-100" onClick={() => setShowDropdown(false)} style={{ zIndex: 1040 }}></div>
//                                     <div className="dropdown-menu-custom shadow border-0 show">
//                                         <div className="py-1">
//                                             <Link className="dropdown-item d-flex align-items-center py-2 px-3" to="/business/profile" onClick={() => {setShowDropdown(false); setIsMenuOpen(false);}}>
//                                                 <i className="ri-user-line me-3 text-primary"></i> Profile
//                                             </Link>
//                                             <Link className="dropdown-item d-flex align-items-center py-2 px-3" to="business/changepassword" onClick={() => {setShowDropdown(false); setIsMenuOpen(false);}}>
//                                                 <i className="ri-lock-line me-3 text-primary"></i> Password
//                                             </Link>
//                                             <hr className="dropdown-divider my-1 mx-3" />
//                                             <button className="dropdown-item d-flex align-items-center py-2 px-3 text-danger" onClick={handleLogout}>
//                                                 <i className="ri-logout-box-r-line me-3"></i> Logout
//                                             </button>
//                                         </div>
//                                     </div>
//                                 </>
//                             )}
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             <style>{`
//                 .rotate-180 { transform: rotate(180deg); transition: transform 0.3s ease; }
//                 .dropdown-menu-custom {
//                     position: absolute;
//                     right: 0;
//                     top: 100%;
//                     min-width: 200px;
//                     background: white;
//                     border-radius: 0.5rem;
//                     z-index: 1050;
//                     border: 1px solid rgba(0,0,0,.05);
//                     display: block;
//                 }
//                 .dropdown-item { width: 100%; text-align: left; background: none; border: none; text-decoration: none; color: #333; font-size: 0.9rem; }
//                 .dropdown-item:hover { background-color: #f8f9fa; color: #065f46; }
                
//                 @media (max-width: 991px) {
//                     .navbar-collapse {
//                         position: absolute; top: 100%; left: 0; width: 100%;
//                         background: white; padding: 15px; box-shadow: 0 10px 15px rgba(0,0,0,0.1);
//                         z-index: 2000;
//                     }
//                     .dropdown-menu-custom { position: static; width: 100%; box-shadow: none; border: none; background: #f9fafb; margin-top: 5px; }
//                 }
//             `}</style>
//         </nav>
//     );
// };

// export default BusinessHeader;




import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const BusinessHeader = () => {
    const navigate = useNavigate();
    const [showDropdown, setShowDropdown] = useState(false);
    const [isNavOpen, setIsNavOpen] = useState(false); // Mobile menu state
    const dropdownRef = useRef(null);

    const handleLogout = () => {
        console.log('Logging out...');
        navigate('/');
    };

    const toggleDropdown = () => {
        setShowDropdown(!showDropdown);
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm fixed-top py-2 py-md-3">
            <div className="container">
                {/* Brand Logo - Responsive Scaling */}
                <Link className="navbar-brand d-flex align-items-center" to="/business/dashboard" style={{ maxWidth: '65%' }}>
                    <svg
                        width="42"
                        height="42"
                        viewBox="0 0 180 120"
                        xmlns="http://www.w3.org/2000/svg"
                        className="brand-svg-mobile"
                        style={{ marginRight: '5px' }}
                    >
                        <text x="0" y="90" fontFamily="Playfair Display, Didot, serif" fontSize="96" fontWeight="700" letterSpacing="-10" fill="#111">MF</text>
                    </svg>
                    <div className="d-flex flex-column brand-text-mobile">
                        <span className="brand-title" style={{ fontSize: '0.9rem', fontWeight: '500', letterSpacing: '0.2rem', color: '#111', lineHeight: '1.1' }}>MUNNY FINDS</span>
                        <span className="text-uppercase fw-bold text-muted" style={{ fontSize: '0.55rem', letterSpacing: '0.05rem' }}>Business Control</span>
                    </div>
                </Link>

                {/* Right side container for Dropdown + Toggler */}
                <div className="d-flex align-items-center gap-1 order-lg-last" ref={dropdownRef}>
                    {/* User Profile Dropdown */}
                    <div className="dropdown" style={{ position: 'relative' }}>
                        <button 
                            className="btn d-flex align-items-center gap-1 border-0 bg-transparent p-1 p-md-2"
                            onClick={toggleDropdown}
                            aria-expanded={showDropdown}
                        >
                            <div className="rounded-circle overflow-hidden d-flex align-items-center justify-content-center"
                                 style={{ 
                                     backgroundColor: '#065f46', 
                                     width: '35px', 
                                     height: '35px', 
                                     color: '#fff'
                                 }}>
                                <i className="ri-user-fill fs-5"></i>
                            </div>
                            <span className="fw-semibold text-dark d-none d-md-inline ms-1" style={{ fontSize: '0.9rem' }}>My Salon</span>
                            {/* THE DROPDOWN SYMBOL YOU REQUESTED */}
                            <i className={`ri-arrow-down-s-line small ${showDropdown ? 'rotate-180' : ''}`}></i>
                        </button>
                        
                        {/* Dropdown Menu */}
                        {showDropdown && (
                            <div 
                                className="dropdown-menu show shadow-lg border-0 rounded-3 position-absolute end-0 mt-2"
                                style={{
                                    minWidth: '200px',
                                    backgroundColor: 'white',
                                    zIndex: 1050,
                                    display: 'block'
                                }}
                            >
                                <div className="px-3 py-3 border-bottom d-md-none">
                                    <h6 className="mb-0 fw-bold" style={{ fontSize: '0.85rem' }}>My Salon</h6>
                                </div>
                                <div className="py-2">
                                    <Link className="dropdown-item d-flex align-items-center py-2 px-3" to="/business/profile" onClick={() => setShowDropdown(false)}>
                                        <i className="ri-user-line me-2 text-primary"></i>
                                        <span>Profile</span>
                                    </Link>
                                    <Link className="dropdown-item d-flex align-items-center py-2 px-3" to="business/changepassword" onClick={() => setShowDropdown(false)}>
                                        <i className="ri-lock-line me-2 text-primary"></i>
                                        <span>Change Password</span>
                                    </Link>
                                    <div className="dropdown-divider my-1"></div>
                                    <button 
                                        className="dropdown-item d-flex align-items-center py-2 px-3 text-danger w-100 border-0 bg-transparent text-start" 
                                        onClick={() => { setShowDropdown(false); handleLogout(); }}
                                    >
                                        <i className="ri-logout-box-r-line me-2"></i>
                                        <span>Logout</span>
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Navbar Toggler */}
                    <button 
                        className="navbar-toggler border-0 p-1 ms-1" 
                        type="button" 
                        onClick={() => setIsNavOpen(!isNavOpen)}
                    >
                        <span className="navbar-toggler-icon" style={{ width: '1.2em', height: '1.2em' }}></span>
                    </button>
                </div>

                {/* Navbar Links */}
                <div className={`collapse navbar-collapse ${isNavOpen ? 'show' : ''}`} id="adminNavbar">
                    <ul className="navbar-nav mx-auto mb-2 mb-lg-0 gap-lg-3 pt-3 pt-lg-0">
                        <li className="nav-item">
                            <Link className="nav-link fw-semibold text-dark py-2 py-lg-0" to="/business/dashboard" onClick={() => setIsNavOpen(false)}>
                                <i className="ri-dashboard-line me-2 d-lg-none"></i> Dashboard
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link fw-semibold text-dark py-2 py-lg-0" to="/business/appointmentslist" onClick={() => setIsNavOpen(false)}>
                                <i className="ri-calendar-line me-2 d-lg-none"></i> Appointments
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link fw-semibold text-dark py-2 py-lg-0" to="/business/staffs" onClick={() => setIsNavOpen(false)}>
                                <i className="ri-user-line me-2 d-lg-none"></i> Staffs
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link fw-semibold text-dark py-2 py-lg-0" to="/business/services" onClick={() => setIsNavOpen(false)}>
                                <i className="ri-list-check me-2 d-lg-none"></i> Services
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>

            <style>{`
                .rotate-180 {
                    transform: rotate(180deg);
                    transition: transform 0.3s ease;
                }
                @media (min-width: 992px) {
                    .brand-title { font-size: 1.05rem !important; letter-spacing: 0.35rem !important; }
                    .brand-svg-mobile { width: 52px !important; height: 52px !important; }
                }
                @media (max-width: 991px) {
                    .navbar-collapse.show {
                        display: block;
                        background: white;
                        border-top: 1px solid #f1f1f1;
                        padding-bottom: 20px;
                    }
                    .nav-item { border-bottom: 1px solid #eee; }
                }
                .dropdown-item:hover { background-color: #f8f9fa; color: #065f46 !important; }
            `}</style>
        </nav>
    );
};

export default BusinessHeader;